const PATHS = {
  auth: "auth/api/v1/",
  rider: "rider/api/v1/",
  order: "order/api/v1/",
  location: "location/api/v1/",
  payment: "payment/api/v1/",
  customer: "customer/api/v1/",
  vendor: "vendor/api/v1/",
  zone: "order/api/v1/",
};

export default {
  //Auth
  login: {
    url: `${PATHS.auth}auth/login`,
    method: "post",
  },
  validateToken: {
    url: `${PATHS.rider}admin/validate-token`,
    method: "post",
  },
  completeAdminReg: {
    url: `${PATHS.rider}admin/register/complete`,
    method: "put",
  },
  updateAdminProfile: {
    url: `${PATHS.rider}admin/update-profile`,
    method: "put",
  },
  forgotPassword: {
    url: `${PATHS.rider}admin/forgot-password`,
    method: "post",
  },
  verifyOtp: {
    url: `${PATHS.rider}admin/forgot-password/verify-otp`,
    method: "post",
  },
  resendOtp: {
    url: `${PATHS.rider}admin/forgot-password/resend-otp`,
    method: "post",
  },
  resetPassword: {
    url: `${PATHS.rider}admin/reset-password`,
    method: "post",
  },
  refreshToken: {
    url: `${PATHS.auth}auth/refresh`,
    method: "post",
  },

  //Admin User
  createNewAdmin: {
    url: `${PATHS.rider}admin/register`,
    method: "post",
  },
  getAllAdmin: {
    url: `${PATHS.rider}admin`,
    method: "get",
  },
  activateAdmin: (userId) => ({
    url: `${PATHS.rider}admin/activate/${userId}`,
    method: "put",
  }),
  deactivateAdmin: (userId) => ({
    url: `${PATHS.rider}admin/deactivate/${userId}`,
    method: "put",
  }),
  deleteAdmin: (userId) => ({
    url: `${PATHS.rider}admin/remove/${userId}`,
    method: "delete",
  }),
  updateRole: (userId) => ({
    url: `${PATHS.rider}admin/update-role/${userId}`,
    method: "put",
  }),
  getAllRoles: {
    url: `${PATHS.rider}roles`,
    method: "get",
  },
  //Audit Trail
  auditLog: {
    url: `${PATHS.rider}audit-trail`,
    method: "get",
  },

  //Riders
  getAllRiders: (data) => ({
    url: `${PATHS.rider}admin/riders?page=${data.page}${
      data?.searchValue ? `&searchValue=${data.searchValue}` : ""
    }${data.status ? `&status=${data.status}` : ""}${
      data.activated !== "" && data.activated !== undefined
        ? `&activated=${data.activated}`
        : ""
    }${data.startDate ? `&startDate=${data.startDate}` : ""}${
      data.endDate ? `&endDate=${data.endDate}` : ""
    }`,
    method: "get",
  }),
  getIndividualRiders: (riderId) => ({
    url: `${PATHS.rider}admin/riders/${riderId}`,
    method: "get",
  }),
  approveRider: (riderId) => ({
    url: `${PATHS.rider}admin/riders/approve/${riderId}`,
    method: "put",
  }),
  declineRider: (riderId) => ({
    url: `${PATHS.rider}admin/riders/decline/${riderId}`,
    method: "put",
  }),
  getRiderHistory: (data) => ({
    url: `${PATHS.rider}admin/riders/history/${data?.riderId}?page=${data?.page}`,
    method: "get",
  }),
  getAllRiderRequest: (data) => ({
    url: `${PATHS.rider}rider-request?page=${data.page}&startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
  }),
  deactivateRider: (riderId) => ({
    url: `${PATHS.rider}admin/riders/deactivate/${riderId}`,
    method: "put",
  }),
  activateRider: (riderId) => ({
    url: `${PATHS.rider}admin/riders/activate/${riderId}`,
    method: "put",
  }),
  updateRiderTransportMode: (riderId) => ({
    url: `${PATHS.rider}admin/riders/transport-mode/${riderId}`,
    method: "put",
  }),

  //Order
  getAllOrders: (data) => ({
    url: `${PATHS.order}order?page=${data.page}${
      data?.customerName ? `&customerName=${data.customerName}` : ""
    }${data?.status ? `&status=${data.status}` : ""}${
      data?.paymentStatus ? `&paymentStatus=${data.paymentStatus}` : ""
    }${data.startDate ? `&startDate=${data.startDate}` : ""}${
      data.endDate ? `&endDate=${data.endDate}` : ""
    }`,
    method: "get",
  }),
  getIndividualOrder: (id) => ({
    url: `${PATHS.order}order/${id}`,
    method: "get",
  }),
  createOrder: {
    url: `${PATHS.order}order`,
    method: "post",
  },
  getRiderRequest: (id) => ({
    url: `${PATHS.rider}rider-request/${id}`,
    method: "get",
  }),
  cancelOrder: (id) => ({
    url: `${PATHS.order}order/cancel/${id}`,
    method: "put",
  }),
  reassignOrder: {
    url: `${PATHS.rider}rider-request/reassign/rider/order`,
    method: "post",
  },

  //Customers
  getAllCustomers: (data) => ({
    url: `${PATHS.customer}admins/customers?page=${data.page}&limit=10${data.name ? `&name=${data.name}` : ""}${data.gender ? `&gender=${data.gender}` : ""}${data.activated !== "" && data.activated !== undefined ? `&activated=${data.activated}` : ""}${data.startDate ? `&startDate=${data.startDate}` : ""}${data.endDate ? `&endDate=${data.endDate}` : ""}`,
    method: "get",
  }),
  getCustomerStats: {
    url: `${PATHS.customer}admins/customers/stats`,
    method: "get",
  },
  getCustomerById: (id) => ({
    url: `${PATHS.customer}admins/customers/${id}`,
    method: "get",
  }),
  deactivateCustomer: (id) => ({
    url: `${PATHS.customer}admins/customers/${id}/deactivate`,
    method: "put",
  }),
  reactivateCustomer: (id) => ({
    url: `${PATHS.customer}admins/customers/${id}/reactivate`,
    method: "put",
  }),

  //Vendors
  getAllVendors: (data) => ({
    url: `${PATHS.vendor}admins/vendors?page=${data.page}&limit=10${data.name ? `&name=${data.name}` : ""}${data.activated !== "" && data.activated !== undefined ? `&activated=${data.activated}` : ""}${data.status ? `&status=${data.status}` : ""}${data.startDate ? `&startDate=${data.startDate}` : ""}${data.endDate ? `&endDate=${data.endDate}` : ""}`,
    method: "get",
  }),
  getVendorStats: {
    url: `${PATHS.vendor}admins/vendors/stats`,
    method: "get",
  },
  getVendorById: (id) => ({
    url: `${PATHS.vendor}admins/vendors/${id}`,
    method: "get",
  }),
  deactivateVendor: (id) => ({
    url: `${PATHS.vendor}admins/vendors/${id}/deactivate`,
    method: "put",
  }),
  reactivateVendor: (id) => ({
    url: `${PATHS.vendor}admins/vendors/${id}/reactivate`,
    method: "put",
  }),
  approveVendor: (id) => ({
    url: `${PATHS.vendor}admins/vendors/${id}/approve`,
    method: "put",
  }),
  declineVendor: (id) => ({
    url: `${PATHS.vendor}admins/vendors/${id}/decline`,
    method: "put",
  }),
  getVendorItems: (data) => ({
    url: `${PATHS.vendor}admins/vendors/${data?.vendorId}/items?page=${data?.page}&limit=10`,
    method: "get",
  }),

  //Accounts
  getAccountMetrics: (data) => ({
    url: `${PATHS.order}order/metrics?startDate=${data.startDate}&endDate=${data.endDate}`,
    method: "get",
  }),
  getPeriodicTotalEarnings: (data) => ({
    url: `${PATHS.payment}wallet/transactions/total-earnings?startDate=${data?.startDate}&endDate=${data?.endDate}`,
    method: "get",
  }),
  completePayment: {
    url: `${PATHS.payment}wallet/initiate/payout`,
    method: "post",
  },
  getWallet: {
    url: `${PATHS.payment}wallet`,
    method: "get",
  },

  //Dashboard-Location
  getNearbyRider: (data) => ({
    url: `${PATHS.location}location/nearby/riders?longitude=${data?.lng}&latitude=${data?.lat}`,
    method: "get",
  }),
  getRiderLocation: (id) => ({
    url: `${PATHS.location}location/rider/${id}`,
    method: "get",
  }),
  getActiveRiders: {
    url: `${PATHS.location}location/active/riders`,
    method: "get",
  },

  //Zones
  getAllZones: (data) => ({
    url: `${PATHS.zone}zone?page=${data?.page}&limit=${
      data?.limit || 10
    }${data?.search ? `&search=${data.search}` : ""}${
      data?.status ? `&status=${data.status}` : ""
    }`,
    method: "get",
  }),
  getZoneById: (id) => ({
    url: `${PATHS.zone}zone/${id}`,
    method: "get",
  }),
  createZone: {
    url: `${PATHS.zone}zone`,
    method: "post",
  },
  updateZone: (id) => ({
    url: `${PATHS.zone}zone/${id}`,
    method: "put",
  }),
  deleteZone: (id) => ({
    url: `${PATHS.zone}zone/${id}`,
    method: "delete",
  }),
  activateZone: (id) => ({
    url: `${PATHS.zone}zone/${id}/activate`,
    method: "put",
  }),
  deactivateZone: (id) => ({
    url: `${PATHS.zone}zone/${id}/deactivate`,
    method: "put",
  }),

  //Zone Pricing
  getAllZonePrices: (data) => ({
    url: `${PATHS.zone}zone-price?page=${data?.page}&limit=${data?.limit || 20}`,
    method: "get",
  }),
  createZonePrice: {
    url: `${PATHS.zone}zone-price`,
    method: "post",
  },
  updateZonePrice: (id) => ({
    url: `${PATHS.zone}zone-price/${id}`,
    method: "put",
  }),
  deleteZonePrice: (id) => ({
    url: `${PATHS.zone}zone-price/${id}`,
    method: "delete",
  }),

  //Fees
  getAllFees: (data) => ({
    url: `${PATHS.order}fee?page=${data?.page || 1}&limit=${data?.limit || 20}`,
    method: "get",
  }),
  createFee: {
    url: `${PATHS.order}fee`,
    method: "post",
  },
  updateFee: (id) => ({
    url: `${PATHS.order}fee/${id}`,
    method: "put",
  }),
  deleteFee: (id) => ({
    url: `${PATHS.order}fee/${id}`,
    method: "delete",
  }),
};
